/**
 * InteractiveSection.tsx
 * Interactive section showing links, button groups and other interactive elements
 */

import React from 'react';
import { Card, CardHeader, CardBody, CardFooter } from '@enfomentis/ui';
import { Button } from '@enfomentis/ui';
import { ButtonGroup } from '@enfomentis/ui';
import { Divider } from '@enfomentis/ui';
import { Link } from '@enfomentis/ui';

interface InteractiveSectionProps {
  onBackToOverview: () => void;
}

export const InteractiveSection: React.FC<InteractiveSectionProps> = ({ onBackToOverview }) => {
  return (
    <div className="space-y-6">
      <Card shadow="lg" isHoverable>
        <CardHeader>
          <h3 className="text-xl font-semibold text-text-primary">Interactive Elements</h3>
        </CardHeader>
        <CardBody>
          <div className="space-y-8">
            {/* Links */}
            <div>
              <h4 className="text-lg font-semibold text-text-primary mb-4">Links</h4>
              <div className="space-y-3">
                <div>
                  <Link href="#" color="primary">Primary Link</Link>
                  <span className="mx-2">•</span>
                  <Link href="#" color="secondary">Secondary Link</Link>
                  <span className="mx-2">•</span>
                  <Link href="#" color="success">Success Link</Link>
                </div>
                <div>
                  <Link href="https://heroui.com" isExternal showAnchorIcon>
                    External Link with Icon
                  </Link>
                </div>
              </div>
            </div>

            <Divider />

            {/* ButtonGroup */}
            <div>
              <h4 className="text-lg font-semibold text-text-primary mb-4">Button Groups</h4>
              <div className="space-y-4">
                <ButtonGroup
                  options={[
                    { label: 'Option 1', value: '1' },
                    { label: 'Option 2', value: '2' },
                    { label: 'Option 3', value: '3' }
                  ]}
                  value="1"
                  onChange={() => {}}
                  variant="solid"
                />
                <ButtonGroup
                  options={[
                    { label: 'Flat 1', value: '1' },
                    { label: 'Flat 2', value: '2' },
                    { label: 'Flat 3', value: '3' }
                  ]}
                  value="2"
                  onChange={() => {}}
                  variant="flat"
                />
              </div>
            </div>
          </div>
        </CardBody>
        <CardFooter>
          <div className="flex justify-between items-center w-full">
            <p className="text-sm text-text-secondary">
              All interactive elements automatically adapt to the current theme
            </p>
            {onBackToOverview && (
              <Button color="primary" onPress={onBackToOverview}>
                Back to Overview
              </Button>
            )}
          </div>
        </CardFooter>
      </Card>
    </div>
  );
};